import React, {useContext} from 'react';

import { defaultColumns } from "../BookingsListColumns";
import { useDispatch, useSelector } from "react-redux";
import { amenityFilterChanged, statusFilterChanged } from "../../../Redux/FiltersReducer";
import AmenityFilterSelector from "../../AmenityFilterSelector";
import StatusSelector from "../../StatusSelector";
import { TabContext } from "../../../Pages/BookingsLog";

const BookingListFilterRow = (props) => {
    const dispatch = useDispatch();

    const {view, scope} = useContext(TabContext);

    const amenityFilters = useSelector(state => state.module.BOOKINGS.filters.amenity);
    const categoryFilter = useSelector(state => state.module.BOOKINGS.filters.category);
    const statusFilters = useSelector(state => state.module.BOOKINGS.filters.status);

    const columns = props.columnData ?? {...defaultColumns}

    const getFilterCell = (columnKey) => {
        switch (columnKey) {
            case 'amenity':
                return (
                    <AmenityFilterSelector
                        includeAll
                        value={amenityFilters}
                        onChange={e => dispatch(amenityFilterChanged(e.target.value))}
                        category={categoryFilter}
                    />
                )

            case 'status': {
                return (
                    <StatusSelector
                        type={scope}
                        value={statusFilters}
                        onChange={e => dispatch(statusFilterChanged(e.target.value))}
                    />
                )
            }
            default:
                return null
        }
    }
    return (
        <tbody className="filter-row">
            <tr>
                { Object
                    .keys(columns)
                    .map(key =>
                        <th key={key}
                            className={`filter-row-cell filter-row-${columns[key].key} sticky-row`}
                        >
                            {getFilterCell(columns[key].key)}
                        </th>
                    )
                }
            </tr>
        </tbody>
    );
}

export default BookingListFilterRow;


